var moduleMap = {
	"./constants": () => {
		return __webpack_require__.e(289).then(() => (() => ((__webpack_require__(9289)))));
	},
	"./types": () => {
		return __webpack_require__.e(616).then(() => (() => ((__webpack_require__(9616)))));
	},
	"./ContentItemCopyAssistant": () => {
		return Promise.all([__webpack_require__.e(318), __webpack_require__.e(79), __webpack_require__.e(467), __webpack_require__.e(411), __webpack_require__.e(308), __webpack_require__.e(644)]).then(() => (() => ((__webpack_require__(644)))));
	},
	"./StagedContentAssistant": () => {
		return Promise.all([__webpack_require__.e(318), __webpack_require__.e(79), __webpack_require__.e(467), __webpack_require__.e(411), __webpack_require__.e(337)]).then(() => (() => ((__webpack_require__(8337)))));
	},
	"./StagedContentAssistantOverview": () => {
		return Promise.all([__webpack_require__.e(318), __webpack_require__.e(79), __webpack_require__.e(467), __webpack_require__.e(411), __webpack_require__.e(983), __webpack_require__.e(163), __webpack_require__.e(308), __webpack_require__.e(422)]).then(() => (() => ((__webpack_require__(5304)))));
	},
	"./ContentTypeIcon": () => {
		return Promise.all([__webpack_require__.e(318), __webpack_require__.e(983), __webpack_require__.e(613)]).then(() => (() => ((__webpack_require__(7613)))));
	},
	"./ContentTypeBadge": () => {
		return Promise.all([__webpack_require__.e(318), __webpack_require__.e(79), __webpack_require__.e(983), __webpack_require__.e(163), __webpack_require__.e(415)]).then(() => (() => ((__webpack_require__(8163)))));
	},
	"./hooks": () => {
		return Promise.all([__webpack_require__.e(318), __webpack_require__.e(79), __webpack_require__.e(467), __webpack_require__.e(919)]).then(() => (() => ((__webpack_require__(9919)))));
	},
	"./utils": () => {
		return Promise.all([__webpack_require__.e(79), __webpack_require__.e(2)]).then(() => (() => ((__webpack_require__(1002)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});